export const MODE_FITTING = 'MODE_FITTING';
export const MODE_PRELOAD = 'MODE_PRELOAD';
export const MODE_DISTRICT = 'MODE_DISTRICT';
